import {lazyLoad} from "../../../../utils/loadable";

export const ShoutoutAwardsGenerateDone = lazyLoad(
  () => import('./index'),
  module => module.ShoutoutAwardsGenerateDone,
);
